export const formatIndianNumber = (num) => {
  if (!num && num !== 0) return "";

  const absNum = Math.abs(num);

  if (absNum >= 10000000) {
    const cr = (num / 10000000).toFixed(2).replace(/\.00$/, "").replace(/(\.\d)0$/, "$1");
    return `₹ ${cr} Cr`;
  }

  if (absNum >= 100000) {
    const lakh = (num / 100000).toFixed(2).replace(/\.00$/, "").replace(/(\.\d)0$/, "$1");
    return `₹ ${lakh} Lakhs`;
  }

  if (absNum >= 1000) {
    return `₹ ${num.toLocaleString("en-IN")}`;
  }

  return `₹ ${num.toString()}`;
};

export const parseIndianNumber = (str) => {
  if (typeof str === "number") return str;
  if (!str) return 0;

  const value = str.toString().toLowerCase().trim().replace(/,/g, "");

  const crMatch = value.match(/^([\d.]+)\s*(cr|crore|crores)$/);
  if (crMatch) {
    const val = parseFloat(crMatch[1]);
    return isNaN(val) ? 0 : Math.round(val * 10000000);
  }

  const lakhMatch = value.match(/^([\d.]+)\s*(lakh|lakhs|lac|lacs|l)$/);
  if (lakhMatch) {
    const val = parseFloat(lakhMatch[1]);
    return isNaN(val) ? 0 : Math.round(val * 100000);
  }

  const kMatch = value.match(/^([\d.]+)\s*(k|thousand)$/);
  if (kMatch) {
    const val = parseFloat(kMatch[1]);
    return isNaN(val) ? 0 : Math.round(val * 1000);
  }

  const num = parseFloat(value);
  return isNaN(num) ? 0 : num;
};